import Spinner from "../../../shared/UxbiSpinner";
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import AsyncSelectERP from "../../common/AsyncSelectERP";
import {
  getClientes,
  getEncabezado,
  getAgentesVentas,
  getProbabilidadesCierre,
} from "../../../api/uxbi";
import { getCurrentUser } from "../../utils/getCurrentUser";
import WdowConfirm from "../../utils/WdowConfirm";
import { toast } from "react-toastify";

export default function OportunidadFormModal({
  show,
  onHide,
  onSubmit,
  record,
  isEditMode = false,
}) {
  const session = getCurrentUser();
  const initialState = {
    cliente: null,
    probabilidad: null,
    agenteVentas: null,
    nombre: "",
    montoProyecto: "",
    fechaTentativaCierre: "",
  };

  const [form, setForm] = useState(initialState);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    step: null,
    data: [],
    payload: null,
  });
  const [loading, setLoading] = useState(false);

  const styles = {
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255,255,255,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1055,
    },
    spinnerContainer: {
      textAlign: "center",
    },
  };

  useEffect(() => {
    if (!show) return;

    // CREACIÓN
    if (!isEditMode) {
      setForm({
        ...initialState,
        agenteVentas: {
          value: session.id,
          label: session.nombre,
        },
      });
      return;
    }

    // EDICIÓN
    if (record) {
      setForm({
        nombre: record.nombre || "",
        montoProyecto: record.monto_proyecto || "",
        fechaTentativaCierre: record.fecha_tentativa_cierre || "",

        cliente: record.cliente
          ? { value: record.cliente.id, label: record.cliente.nombre }
          : null,

        probabilidad: record.probabilidad
          ? {
              value: record.probabilidad.id,
              label: record.probabilidad.descripcion,
            }
          : null,

        fuente: record.fuente
          ? { value: record.fuente.id, label: record.fuente.descripcion }
          : null,

        agenteVentas: record.agente_ventas
          ? {
              value: record.agente_ventas.id,
              label: record.agente_ventas.nombre,
            }
          : null,

        encabezado: record.encabezado
          ? {
              value: record.encabezado.id,
              label:
                "F-" +
                record.encabezado.folio +
                " / $" +
                record.encabezado.importe,
            }
          : null,
      });
    }
  }, [show, record, isEditMode]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const fieldLabels = {
    probabilidad: "Probabilidad de Cierre",
  };

  const getRequiredFields = (isEditMode) => {
    return ["probabilidad"];
  };

  const getMissingFields = (form, isEditMode) => {
    const missing = [];
    const requiredFields = getRequiredFields(isEditMode);

    requiredFields.forEach((field) => {
      const value = form[field];

      const isEmpty =
        value === undefined ||
        value === null ||
        value === "" ||
        (typeof value === "object" && !value.value && !value.length);

      if (isEmpty) {
        missing.push(field);
      }
    });

    return missing;
  };

  async function handleSubmit() {
    const missingFields = getMissingFields(form, isEditMode);
    if (missingFields.length > 0) {
      toast.warning(
        <div>
          <strong>Faltan por completar los siguientes campos:</strong>
          <br />
          <br />
          {missingFields.map((field) => (
            <div key={field}>• {fieldLabels[field]}</div>
          ))}
        </div>,
        { autoClose: 6000 },
      );

      return;
    }

    setLoading(true);

    const payload = {
      id: record?.id ?? null,
      nombre: form.nombre,
      probabilidad_cierre: form.probabilidad?.value,
      fecha_tentativa_cierre: form.fechaTentativaCierre,
      id_agente_ventas: form.agenteVentas?.value,
      id_cliente: form.cliente?.value,
      monto_proyecto: form.montoProyecto,
      id_encabezado: form.encabezado?.value,
      id_probabilidad_cierre: form.probabilidad?.value,
    };

    try {
      if (isEditMode) {
        await onSubmit(payload);

        toast.success("Cambios guardados correctamente");

        setLoading(false);
        onHide();
        return;
      }

      setLoading(false);

      setConfirmModal({
        show: true,
        type: "confirmar",
        data: null,
        payload,
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error("Error al procesar petición.");
      throw error;
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditMode
            ? "EDITAR OPORTUNIDAD " + form.nombre
            : "NUEVA OPORTUNIDAD"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ position: "relative" }}>
        <Form>
          <Row className="g-2">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Nombre de la Oportunidad</Form.Label>
                <Form.Control
                  value={form.nombre}
                  minlength="10"
                  maxlength="13"
                  onChange={(e) => handleChange("nombre", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Cliente</Form.Label>
                <AsyncSelectERP
                  value={form.cliente}
                  loadOptionsApi={getClientes}
                  onChange={(option) => handleChange("cliente", option)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2 mt-1">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Cotización</Form.Label>

                {!form.cliente ? (
                  <p className="text-muted">
                    <i>Selecciona un cliente para ver sus cotizaciones...</i>
                  </p>
                ) : (
                  <AsyncSelectERP
                    value={form.encabezado}
                    loadOptionsApi={getEncabezado}
                    additionalFilters={[
                      {
                        property: "clave_documento_tipo",
                        value: "CVTA",
                        relation: "documentoTipo",
                        operator: "=",
                        condition: "AND",
                      },
                      {
                        property: "id_cliente",
                        value: form.cliente.value,
                        operator: "=",
                        condition: "AND",
                      },
                    ]}
                    onChange={(option) => handleChange("encabezado", option)}
                  />
                )}
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Probabilidad de Cierre</Form.Label>
                <AsyncSelectERP
                  value={form.probabilidad}
                  loadOptionsApi={getProbabilidadesCierre}
                  onChange={(option) => handleChange("probabilidad", option)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2 mt-1">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Monto de la Oportunidad</Form.Label>
                <Form.Control
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9]*"
                  value={form.montoProyecto}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d*\.?\d*$/;
                    if (regex.test(value)) {
                      setForm((prev) => ({
                        ...prev,
                        montoProyecto: value,
                      }));
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Fecha de ingreso</Form.Label>
                <Form.Control
                  type="date"
                  value={form.fechaTentativaCierre}
                  onChange={(e) =>
                    handleChange("fechaTentativaCierre", e.target.value)
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="g-2 mt-1">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  Agente de Ventas <span style={{ color: "red" }}> *</span>
                </Form.Label>
                <AsyncSelectERP
                  value={form.agenteVentas}
                  loadOptionsApi={getAgentesVentas}
                  onChange={(option) => handleChange("agenteVentas", option)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}></Col>
          </Row>
        </Form>
        <WdowConfirm
          show={confirmModal.show}
          onHide={() => setConfirmModal({ show: false })}
          onConfirm={async () => {
            try {
              setLoading(true);
              setConfirmModal({ show: false });
              await onSubmit(confirmModal.payload);
              toast.success("Se ha creado correctamente la oportunidad.");
            } catch (e) {
              console.error(e);
              toast.error("Error al crear la oportunidad");
              throw e;
            } finally {
              setLoading(false);
            }
          }}
          title={"Confirmar creación"}
          message={`¿Deseas crear "${form.nombre}"?`}
          type={"confirm"}
          data={confirmModal.data}
        />
        {loading && (
          <div style={styles.overlay}>
            <div style={styles.spinnerContainer}>
              <Spinner label="Guardando…" />
              <div style={{ marginTop: 10, fontWeight: 500 }}>Guardando...</div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>

        <Button variant="success" onClick={handleSubmit} disabled={loading}>
          {isEditMode ? "Actualizar Oportunidad" : "Crear Oportunidad"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
